import {
    BORRAR_TURNO,
    BORRAR_TURNO_EXITO,
    BORRAR_TURNO_ERROR
} from '../types';

import clienteAxios from '../config/axios';

export function borrarTurnoAction(informacion) {
    return async (dispatch) => {
        dispatch(borrarTurno());

        try {
            const { config, payload } = informacion;

            const respuesta = await clienteAxios.post(
                '/paciente/borrarturno',
                payload,
                config
            );

            dispatch(borrarTurnoExito(respuesta.data));

            return respuesta.data;

        } catch (error) {
            const mensajeError =
                error.response?.data?.msg ||
                error.response?.data?.message ||
                error.response?.data?.error ||
                'No se pudo borrar el turno';

            dispatch(borrarTurnoError(mensajeError));

            error.userMessage = mensajeError;

            throw error;
        }
    };
}

const borrarTurno = () => ({
    type: BORRAR_TURNO,
    payload: true
});

const borrarTurnoExito = (data) => ({
    type: BORRAR_TURNO_EXITO,
    payload: data
});

const borrarTurnoError = (msg) => ({
    type: BORRAR_TURNO_ERROR,
    payload: msg
});